var map = {
	"./avantajlarimiz.subPage.js": 18210,
	"./beslenme.subPage.js": 91451,
	"./guvenlik.subPage.js": 35689,
	"./rehberlik.subPage.js": 77057,
	"./saglik.subPage.js": 7341,
	"./servis.subPage.js": 99646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46539;